import { Button, Flex } from '@billy/design-system'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoicingSettingsHost } from '../../../../contexts/invoicingSettingsHostContext'

export const InvoicingSettingsModalFooterActions = (): ReactElement => {
  const { t } = useTranslation()
  const { isDirty, isProcessing, save } = useInvoicingSettingsHost()

  const handleSaveChangesButtonClick = useCallback(() => {
    save()
  }, [save])

  return (
    <Flex justifyContent="flex-end">
      <Button disabled={!isDirty || isProcessing} loading={isProcessing} onClick={handleSaveChangesButtonClick}>
        {t('save_changes')}
      </Button>
    </Flex>
  )
}
